import type { FC, ReactNode } from 'react'

import { ArrowRight } from 'lucide-react'
import { ButtonLink } from '@/components/generals/button'

interface CtaBannerProps {
    title?: string
    description?: string
    href?: string
    label?: string
}

export const CtaBanner: FC<CtaBannerProps> = ({
    title = "Ready for warmer, quieter rooms?",
    description = "Book a free home survey and get a clear, fixed quote with no pressure to commit.",
    href = '/contact',
    label = "Get a free quote"
}): ReactNode => {
    return (
        <section id='get-a-quote' aria-labelledby='get-a-quote-heading' className='px-5 pb-20 sm:px-8 lg:pb-28'>
            <div className='relative isolate mx-auto max-w-7xl overflow-hidden rounded-2xl bg-brand px-6 py-12 text-brand-foreground sm:px-12 sm:py-14 lg:flex lg:items-center lg:justify-between lg:gap-10 lg:px-16'>
                <div aria-hidden='true' className='absolute -right-16 -top-16 -z-10 grid size-72 grid-cols-2 gap-3 opacity-25 sm:size-80'>
                    <span className='rounded-xl border-2 border-brand-foreground/50' />
                    <span className='rounded-xl border-2 border-brand-foreground/50' />
                    <span className='rounded-xl border-2 border-brand-foreground/50' />
                    <span className='rounded-xl bg-brand-foreground/20' />
                </div>

                <div className='max-w-2xl'>
                    <h2 id='get-a-quote-heading' className='text-balance font-heading text-3xl font-semibold tracking-tight sm:text-4xl'>
                        {title}
                    </h2>

                    <p className='mt-3 text-pretty text-base leading-relaxed text-brand-foreground/80 sm:text-lg'>
                        {description}
                    </p>
                </div>

                <ButtonLink href={href} variant='primary' size='lg' className='mt-8 w-full sm:w-auto lg:mt-0'>
                    {label}
                    <ArrowRight aria-hidden='true' />
                </ButtonLink>
            </div>
        </section>
    )
}
